import { render, staticRenderFns } from "./NotificationsListContainer.vue?vue&type=template&id=6c026f4c"
import script from "./NotificationsListContainer.vue?vue&type=script&lang=js"
export * from "./NotificationsListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports